import { http } from '@article/pixel';
import Tracking from '@/components/commons/Tracking';
import { reactive, computed, toRefs } from '@vue/composition-api';
import Time from '@article/time';

const apiURL = `/api/products/getDeliveryEstimate`;

export default function useDeliveryEstimate() {
  const state = reactive({
    initialised: false,
    loading: false,
    error: false,
    accurate: computed(() => state.location.city && state.location.region),
    location: {
      city: null,
      country: null,
      region: null
    },
    estimate: {
      availableDate: null,
      endDeliveryETA: null,
      inStockIn: null,
      productId: null,
      productIsInStock: null,
      regionId: null,
      regionName: null,
      serviceAreaIsGuaranteed: null,
      startDeliveryETA: null,
      warehouseCode: null,
      warehouseIsPrimary: null,
      warehouseTimeZone: null
    },
    estimateMessage: computed(() => {
      if(!state.initialised) {
        return '';
      }

      if(state.estimate && state.estimate.startDeliveryETA && state.estimate.endDeliveryETA) {
        return Time.formatDateRange(state.estimate.startDeliveryETA, state.estimate.endDeliveryETA);
      }
      return 'Please contact us for an estimate';
    })
  });

  async function load({ product, zip }) {
    try {
      state.loading = true;
      const estimate = await http.get(apiURL, {
        productId: product,
        zip,
      }) || {};

      state.initialised = true;
      state.loading = false;
      state.error = false;
      state.location.city = estimate.city;
      state.location.country = estimate.countryId;
      state.location.region = estimate.regionCode;

      Object.assign(state.estimate, estimate.productDeliveryInfo);
    } catch (error) {
      state.loading = false;
      state.error = true;
      Tracking.sentryCaptureError(error);
    }
  }

  return {
    ...toRefs(state),
    load
  };
}
